import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  getProfileImageWithFallback,
  handleImageError,
} from "../utils/imageUtils";
import styles from "./MyPage.module.css";

const MyPage: React.FC = () => {
  const { currentUser, userProfile, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      console.error("로그아웃 오류:", error);
    }
  };

  const menuItems = [
    {
      id: "profile",
      title: "프로필 수정",
      icon: "/images/icons/mypage-profile.svg",
      description: "내 정보를 수정할 수 있어요",
      hasArrow: true,
    },
    {
      id: "pets",
      title: "반려동물 관리",
      icon: "/images/icons/mypage-pets.svg",
      description: "우리 아이들 정보를 관리해보세요",
      hasArrow: true,
    },
    {
      id: "posts",
      title: "내가 쓴 글",
      icon: "/images/icons/mypage-posts.svg",
      description: "작성한 게시글을 확인할 수 있어요",
      hasArrow: true,
    },
    {
      id: "bookmarks",
      title: "북마크",
      icon: "/images/icons/mypage-bookmark.svg",
      description: "저장한 장소와 글을 모아봐요",
      hasArrow: true,
    },
    {
      id: "notifications",
      title: "알림 설정",
      icon: "/images/icons/mypage-notification.svg",
      description: "알림 받을 내용을 설정해보세요",
      hasArrow: true,
    },
    {
      id: "customer-service",
      title: "고객센터",
      icon: "/images/icons/mypage-support.svg",
      description: "문의사항이나 도움이 필요할 때",
      hasArrow: true,
    },
  ];

  return (
    <div className={styles.myPage}>
      {/* 헤더 */}
      <div className={styles.header}>
        <h1>마이페이지</h1>
      </div>

      <div className={styles.container}>
        {!currentUser ? (
          /* 로그인이 필요한 경우 */
          <div className={styles.authSection}>
            <div className={styles.authRequired}>
              <div className={styles.authIcon}>
                <img
                  src="/images/icons/mypage-user-placeholder.svg"
                  alt="로그인 필요"
                />
              </div>
              <h3>로그인이 필요해요</h3>
              <p>펫밀리의 다양한 서비스를 이용해보세요</p>
              <div className={styles.authButtons}>
                <Link to="/login" className={styles.loginButton}>
                  로그인
                </Link>
                <Link to="/register" className={styles.registerButton}>
                  회원가입
                </Link>
              </div>
            </div>
          </div>
        ) : (
          /* 로그인된 경우 */
          <div className={styles.userSection}>
            <div className={styles.profileCard}>
              <div className={styles.profileInfo}>
                <div className={styles.profileAvatar}>
                  <img
                    src={getProfileImageWithFallback(userProfile?.profileImage)}
                    alt="프로필"
                    onError={handleImageError}
                  />
                </div>
                <div className={styles.profileDetails}>
                  <h3>
                    {userProfile?.name || currentUser?.displayName || "사용자"}
                  </h3>
                  <p>{currentUser?.email}</p>
                  <div className={styles.profileStats}>
                    <span>게시글 0</span>
                    <span>•</span>
                    <span>댓글 0</span>
                    <span>•</span>
                    <span>북마크 0</span>
                  </div>
                </div>
              </div>
              <button onClick={handleLogout} className={styles.logoutButton}>
                <img src="/images/icons/mypage-logout.svg" alt="로그아웃" />
              </button>
            </div>
          </div>
        )}

        {/* 메뉴 섹션 */}
        <div className={styles.menuSection}>
          {menuItems.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <img src={item.icon} alt={item.title} />
              </div>
              <div className={styles.menuContent}>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
              {item.hasArrow && (
                <div className={styles.menuArrow}>
                  <img src="/images/icons/arrow-right.svg" alt="이동" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 하단 정보 섹션 */}
        <div className={styles.infoSection}>
          <div className={styles.infoItem}>
            <span>버전 정보</span>
            <span>1.0.0</span>
          </div>
          <div className={styles.infoItem}>
            <span>개인정보처리방침</span>
            <img src="/images/icons/arrow-right.svg" alt="이동" />
          </div>
          <div className={styles.infoItem}>
            <span>서비스 이용약관</span>
            <img src="/images/icons/arrow-right.svg" alt="이동" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPage;
